import * as React from "react";
const SvgTick = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, fill: "none", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m5 12 4.5 3L17 3", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgTick;
